function addListPopupCode(
  controller,
  $scope,
  forEachEnhancement,
  onShow,
  gridInit
) {
  controller.listData = [];
  controller.selectedItem = null; // the "return" if an item is selected

  $scope.ctrl = controller;
  controller.gridCtrl = null;

  controller.close = function() {
    ang.callInParents($scope, 'closePopover')();
  };

  controller.cellDblClick = function(rowData, rowIndex, args) {
    controller.selected();
  };

  controller.selected = function() {
    controller.selectedItems = controller.gridCtrl.getSelectedRows();

    var resultFuncName = ang.getInParents($scope, 'tt_result');

    if (resultFuncName != null) {
      var elements = controller.selectedItems
        // Remove "not allowed" entries
        .filter(function(item) {
          return !forEachEnhancement || forEachEnhancement(item);
        })
        // Return only data, not grid rows
        .map(function(item) {
          return $.extend(true, {}, item.data);
        });

      if (controller.hasResultFunctionMultipleArgs) {
        ang.callInParents($scope, resultFuncName)({ elements: elements });
      } else {
        ang.callInParents($scope, resultFuncName)(elements);
      }
    } else {
      console.debug('resultfuncName is null', $scope);
    }
    controller.gridCtrl.clearSelection();
    controller.close();
  };
  controller.gridInit = function(gridController, gridScope, gridElement) {
    controller.gridCtrl = gridController;
    $scope.gridCtrl = controller.gridCtrl;
    $scope.gridScope = gridScope;
    if (gridInit) gridInit(controller.gridCtrl);
  };
  controller.visible = false;
  controller.onShow = function(scope, tooltip) {
    controller.selectedItem = null;
    controller.listData = null;
    if (controller.visible) controller.gridCtrl.clearSelection();

    controller.visible = true;

    onShow(); // requires to set listdata here
  };

  // register onShow in popover component. This is not the angular way of doing it.TODO: find a better way if possible (ASG)
  ang.callInParents($scope, 'registerShowTooltipHandler')(controller.onShow);
}

global.addListPopupCode = addListPopupCode;

function corePopupListController(
  controller,
  $http,
  $scope,
  $rootScope,
  objectType,
  baseUrl
) {
  $scope.$rootScope = $rootScope;

  if (ang.getInParents($scope, 'enableBackToCore')) {
    $scope.goBackToCore = ang.getInParents($scope, 'goBackToCore'); // goback to core function if available
  }

  $scope.callInParents = function(fnName) {
    return ang.callInParents($scope, fnName);
  };

  controller.httpRequest = function(
    controller,
    baseUrl,
    pathExt,
    serviceParam
  ) {
    if (serviceParam == '') serviceParam = undefined;

    var url = baseUrl;
    if (pathExt) url += pathExt;

    $http
      .get(url, {
        params: {
          param: serviceParam
        }
      })
      .then(
        function(response) {
          var data = response.data;
          if (data.error) {
            app.finishLoading();
            //$rootScope.alertController.addTemporaryAlert(data.msg,'error');
            console.debug('Error in Popup', data);
            controller.errorMessage = data.msg;
            console.debug(' error msg', $scope.errorMessage);
            controller.listData = [];
          } else {
            if (controller.gridCtrl) controller.gridCtrl.clearSelection();
            app.finishLoading();

            // Filter invalid fields (crops) and field groups, otherwise show all data
            controller.listData =
              objectType === 'field' || objectType === 'fieldGroup'
                ? data.filter(function(item) {
                    return item.invalid === false;
                  })
                : data;
          }
        },
        function() {
          // TODO: Handle error
          app.finishLoading();
          controller.listData = null;
        }
      );
  };

  controller.showInactive = false;
  return addListPopupCode(
    controller,
    $scope,
    // foreach
    function(ob) {
      ob.data._objectType = objectType.toLowerCase(); // currently the objecttype is used lowercase
      return true;
    },
    // onshow
    function() {
      var pathExt = ang.getInParents($scope, 'pathExt');
      var serviceParam = ang.getInParents($scope, 'serviceParam');

      if (!pathExt)
        // nur aktive zeigen
        pathExt = '/ActiveOnly';

      app.startLoading();
      var currentlyShowInactive = false;

      if (pathExt == '/ActiveOnly') {
        controller.showActiveOnlyLine = true;
        ang.watchOnce(controller, $scope, 'ctrl.showInactive', function() {
          // $log.debug('showInactive changed');
          if (currentlyShowInactive != controller.showInactive) {
            currentlyShowInactive = controller.showInactive;

            if (currentlyShowInactive) pathExt = '';
            else pathExt = '/ActiveOnly';

            app.startLoading();

            controller.httpRequest(controller, baseUrl, pathExt, serviceParam);

            //						    var data = service.query({ pathExt: pathExt, param: serviceParam }, function(){
            //						    	if(controller.gridCtrl)
            //						    		controller.gridCtrl.clearSelection();
            //						      	app.finishLoading();
            //						        controller.listData = data;
            //						    });
          }
        });
      }

      controller.httpRequest(controller, baseUrl, pathExt, serviceParam);

      //			    var data = service.query({ pathExt: pathExt, param: serviceParam }, function(){
      //			    	if(controller.gridCtrl)
      //			    		controller.gridCtrl.clearSelection();
      //			      	app.finishLoading();
      //			        controller.listData = data;
      //			    });
    },
    // grid init
    function gridInit(gridCtrl) {
      gridCtrl.setMultiSelectable(ang.getInParents($scope, 'allowMultiSelect'));
      // Set default filters here
      // gridCtrl.setFilter("unit", "LIQUID_L");
    }
  );
}

global.corePopupListController = corePopupListController;
